import styled from '@emotion/styled';

export const TeamMemberFields = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[20],
}));
